import React from "react";
import { Section } from "../ui/Section";
import styles from "../../styles/evento-form.module.css";

export function StepResumen({ form, toSpanishDate }) {
    return (
        <Section title="Resumen">
            <div className={`${styles.card} ${styles.soft}`}>

                <ul className={styles.summary}>
                    <li>
                        <strong>Nombre:</strong> {form.nombre || "—"}
                    </li>

                    <li>
                        <strong>Fechas:</strong>{" "}
                        {toSpanishDate(form.fechaInicio) || "—"} →{" "}
                        {toSpanishDate(form.fechaFin) || "—"}
                    </li>

                    <li>
                        <strong>Actividades:</strong>{" "}
                        {form.actividades.filter((a) => a.tipo).length}
                    </li>

                    <li>
                        <strong>Menús:</strong> {form.menus.length}
                    </li>

                    <li>
                        <strong>Participantes:</strong> {form.participaciones.length}
                    </li>

                    <li>
                        <strong>Cacerías:</strong> {form.cacerias.length}
                    </li>

                    <li>
                        <strong>Estado:</strong>{" "}
                        {form.esProvisional ? "Provisional / Reserva" : "Definitivo"}
                    </li>
                </ul>
            </div>
        </Section>
    );
}
